import { Translations } from "@aws-amplify/ui-components";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { createStyles, Divider, Stack } from "@mantine/core";
import { RpiLabelText, RpiSubTitle, RpiText, RpiTitle, useShowSuccessToast } from "@rpi/openapi-core";
import { I18n } from "aws-amplify";
import { getRoutePath } from "../../../hooks/useNavigateRoute";
import { RpaButtonLink, RpaNavLink } from "../../../components/RpiLink";

const authStyles = createStyles((theme) => ({
  authHeader: {
    alignItems: "center",
    gap: theme.spacing.lg,
    marginBottom: theme.spacing.lg,
    textAlign: "center",
  },
  authFooter: {
    alignItems: "center",
    gap: theme.spacing.md,
  },
  dividerLine: {
    alignSelf: "stretch",
    borderColor: theme.other.semanticColors.divider,
  },
}));

export const resetPasswordComponent: DefaultComponents["ResetPassword"] = {
  Header() {
    const { classes } = authStyles();
    return (
      <Stack className={classes.authHeader}>
        <img src="/logo.svg" width={94} height={94} />
        <RpiTitle>RPI Print API</RpiTitle>
        <RpiSubTitle>Forgot Password</RpiSubTitle>
        <RpiLabelText>
          Please enter your username or email, and we will send you a confirmation code to reset your password.
        </RpiLabelText>
      </Stack>
    );
  },
  Footer() {
    const { classes } = authStyles();
    return (
      <Stack className={classes.authFooter}>
        <RpaNavLink to={getRoutePath("auth:sign-in")}>Back to Sign In</RpaNavLink>
      </Stack>
    );
  },
};

export const confirmResetPasswordComponent: DefaultComponents["ConfirmResetPassword"] = {
  Header() {
    const { classes } = authStyles();
    return (
      <Stack className={classes.authHeader}>
        <img src="/logo.svg" width={94} height={94} />
        <RpiTitle>Reset Password</RpiTitle>
        <RpiText>Please enter the confirmation code sent to your email and your new password below.</RpiText>
      </Stack>
    );
  },
  Footer() {
    const { classes } = authStyles();
    const { resendCode } = useAuthenticator();
    const showSuccessToast = useShowSuccessToast();

    function handleResendCode() {
      resendCode();
      showSuccessToast("A new confirmation code has been sent to your email!");
    }

    return (
      <Stack className={classes.authFooter}>
        <RpaButtonLink onClick={() => handleResendCode()}>Resend Code</RpaButtonLink>
        <Divider className={classes.dividerLine} />
        <RpaNavLink to={getRoutePath("auth:sign-in")}>Go back to Sign In</RpaNavLink>
      </Stack>
    );
  },
};

I18n.putVocabulariesForLanguage("en", {
  [Translations.SUBMIT]: "Save New Password",
  "Send code": "Send Code",
});
